import {useCallback, useState} from 'react';
import appConfig from '../config';
import {toast} from 'react-toastify';

export const useAuthFetch = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const authFetch = useCallback(async (url, options = {}) => {
        setLoading(true);
        setError(null);

        try {
            const response = await appConfig.authFetch(url, options);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.json();

        } catch (error) {
            console.error('Auth fetch error:', error);
            setError(error.message);

            if (error.message.includes('401')) {
                toast.error('Требуется авторизация');
            } else {
                toast.error('Ошибка загрузки данных');
            }

            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    return { authFetch, loading, error };
};